import { RequirementMilestoneAssignmentResponse, RequirementMilestoneAssignmentListResponse, CreateRequirementMilestoneAssignmentRequest } from "@/types/requirementMilestoneAssignmentTypes";
import { Client } from "./client";
import { FusaReply } from "@/types/replyTypes";

export class RequirementMilestoneAssignmentFrontendController {
  client: Client;

  constructor(client?: Client) {
    this.client = client || new Client();
  }

  readAllByRequirementId(requirementId: string): Promise<RequirementMilestoneAssignmentListResponse> {
    return this.client.read(`/api/requirement-milestone-assignments/requirement/${requirementId}`);
  }

  read(id: string): Promise<RequirementMilestoneAssignmentResponse> {
    return this.client.read(`/api/requirement-milestone-assignments/${id}`);
  }

  create(data: CreateRequirementMilestoneAssignmentRequest): Promise<RequirementMilestoneAssignmentResponse> {
    return this.client.create('/api/requirement-milestone-assignments', data);
  }

  delete(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/requirement-milestone-assignments/${id}`);
  }
}
